<template>
  <div class="cooperation-page">
    <div class="page-header">
      <el-page-header @back="$router.go(-1)">
        <template #content>
          <div class="page-title">商户合作</div>
        </template>
      </el-page-header>
    </div>

    <div class="form-container">
      <el-form 
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-position="top"
        class="cooperation-form"
      >
        <div class="form-section">
          <h3 class="section-title">基本信息</h3>
          <el-form-item label="商户名称" prop="merchantName">
            <el-input v-model="formData.merchantName" placeholder="请输入商户名称"></el-input>
          </el-form-item>
          
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="formData.contactName" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="formData.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
        </div>

        <div class="form-section">
          <h3 class="section-title">商户信息</h3>
          <el-form-item label="商户类型" prop="merchantType">
            <el-select v-model="formData.merchantType" placeholder="请选择商户类型" style="width: 100%">
              <el-option label="餐饮" value="restaurant"></el-option>
              <el-option label="零售" value="retail"></el-option>
              <el-option label="娱乐" value="entertainment"></el-option>
              <el-option label="服务" value="service"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="商户地址" prop="address">
            <el-input v-model="formData.address" placeholder="请输入商户详细地址"></el-input>
          </el-form-item>
          
          <el-form-item label="营业时间" prop="businessHours">
            <el-time-picker
              v-model="formData.businessHours"
              is-range
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择营业时间"
              style="width: 100%"
            />
          </el-form-item>
        </div>

        <div class="form-section">
          <h3 class="section-title">合作意向</h3>
          <el-form-item label="合作方式" prop="cooperationType">
            <el-checkbox-group v-model="formData.cooperationType">
              <el-checkbox label="停车优惠">停车优惠</el-checkbox>
              <el-checkbox label="会员积分">会员积分</el-checkbox>
              <el-checkbox label="活动推广">活动推广</el-checkbox>
              <el-checkbox label="其他">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          
          <el-form-item label="优惠方案" prop="discountPlan">
            <el-input 
              v-model="formData.discountPlan" 
              type="textarea" 
              :rows="3" 
              placeholder="请描述您希望提供的停车优惠方案"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="备注说明" prop="remarks">
            <el-input 
              v-model="formData.remarks" 
              type="textarea" 
              :rows="4" 
              placeholder="请详细描述您的合作需求和期望"
            ></el-input>
          </el-form-item>
        </div>

        <div class="form-actions">
          <el-button type="primary" @click="submitForm" :loading="submitting">提交申请</el-button>
          <el-button @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

export default {
  name: 'MerchantCooperation',
  setup() {
    const formRef = ref(null)
    const submitting = ref(false)
    
    const formData = reactive({
      merchantName: '',
      contactName: '',
      phone: '',
      email: '',
      merchantType: '',
      address: '',
      businessHours: [],
      cooperationType: [],
      discountPlan: '',
      remarks: ''
    })
    
    const formRules = {
      merchantName: [
        { required: true, message: '请输入商户名称', trigger: 'blur' }
      ],
      contactName: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
      ],
      merchantType: [
        { required: true, message: '请选择商户类型', trigger: 'change' }
      ],
      address: [
        { required: true, message: '请输入商户地址', trigger: 'blur' }
      ],
      businessHours: [
        { required: true, message: '请选择营业时间', trigger: 'change' }
      ],
      cooperationType: [
        { required: true, message: '请至少选择一种合作方式', trigger: 'change' }
      ]
    }
    
    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          submitting.value = true
          // 这里添加提交表单的API调用
          setTimeout(() => {
            ElMessage.success('提交成功，我们将尽快与您联系')
            resetForm()
            submitting.value = false
          }, 1000)
        }
      })
    }
    
    const resetForm = () => {
      formRef.value.resetFields()
    }
    
    return {
      formRef,
      formData,
      formRules,
      submitting,
      submitForm,
      resetForm
    }
  }
}
</script>

<style scoped>
.cooperation-page {
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background-color: #fff;
  padding: 15px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 16px;
  font-weight: 500;
}

.form-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.cooperation-form {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin: 0 0 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}
</style> 